import React, {useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {sendVirtualPageView} from '../../../shared/utility';
import useJuryData from './useJuryData';
import useJuryStore from '../../../store/juryStore';
import JuryProjectsGrid from './JuryProjectsGrid';

function JuryProjectsList() {
    useJuryData(); // triggers one-time fetch

    const projects = useJuryStore(s => s.projects);

    useEffect(() => {
        sendVirtualPageView("Jury - Teilnehmer");
    }, []);

    return (
        <>
            <Helmet>
                <title>Jury-Voting - Teilnehmer</title>
            </Helmet>
            <JuryProjectsGrid projects={projects}/>
        </>
    );
}

export default JuryProjectsList;
